// extracted by mini-css-extract-plugin
export default {"container":"signUp_container__RRPDt","card":"signUp_card__SCzs7","form":"signUp_form__uDoSa"};